<template>
  <div>
    <div>
      <div>
        <ValidationObserver ref="formCreateAlarmCentral">
          <form>
            <div class="flex flex-wrap">
              <div class="w-full md:w-1/3 px-2 py-2">
                <BaseInput v-model="name" type="text" :field_name="$t('create_alarm_central_page.name')" rules="required" />
              </div>
              <div class="w-full md:w-1/3 px-2 py-2">
                <BaseInput v-model="phone" type="text" :field_name="$t('create_alarm_central_page.phone')" rules="required" />
              </div>
              <div class="w-full md:w-1/3 px-2 py-2">
                <BaseSelect v-model="communication_language" :options="communicationLanguages" nameSelector="name" optionSelector="id" :field_name="$t('communication_language.label')" rules="required" />
                <span class="text-xs italic">{{ $t('communication_language.hint') }}</span>
              </div>
            </div>

            <div class="flex flex-wrap">
              <div class="w-full md:w-1/3 px-2 py-2">
                <BaseInput v-model="email" type="text" :field_name="$t('create_alarm_central_page.email')" rules="required" />
                <span class="text-xs italic">{{ $t('create_alarm_central_page.email_instructions') }}</span>
              </div>
            </div>

            <div class="mx-2 border-b border-secondary-400 my-5"></div>

            <div class="flex flex-wrap">
              <div class="w-full flex-col px-2 py-2">
                <div class="w-full text-gray-600 text-sm font-bold pb-2 font-serif">{{ $t('create_alarm_central_page.sms_section') }} <b class="text-xxs italic font-normal font-sans text-secondary-500">{{ $t('create_alarm_central_page.sms_subtitle') }}</b></div>
                <div class="w-full flex flex-wrap mt-2" v-for="(n, i) in report_phones" :key="i">
                  <div class="w-3/12 pr-2">
                    <BaseInput v-model="n.msisdn" @keypress="isNumber($event)" maxlength="15" type="text" :field_name="$t('create_alarm_central_page.sms_number') + ' ' + (i + 1)" rules="required" />
                  </div>
                  <div class="w-3/12 pr-2">
                    <BaseSelect v-model="n.device_identifier" :options="deviceIdentifiers" nameSelector="name" optionSelector="id" :field_name="$t('create_alarm_central_page.device_identifier') + ' ' + (i + 1)" rules="required" />
                  </div>
                  <div class="w-3/12 pr-2">
                    <BaseSelect v-model="n.report_format" :options="reportFormats" nameSelector="name" optionSelector="id" :field_name="$t('create_alarm_central_page.report_format') + ' ' + (i + 1)" rules="required" />
                  </div>
                  <div class="w-2/12 flex flex-col pr-2 pt-2">
                    <template v-for="s in additionalSettings">
                      <div class="w-full" v-bind:key="s.id">
                        <label class="inline-flex items-center mt-2">
                          <input v-model="n.additional_settings" :value="s.id" type="checkbox" class="form-checkbox h-3 w-3" />
                          <span class="ml-2 text-gray-600 text-sm font-sans font-semibold">{{ s.name }}</span>
                        </label>
                      </div>
                    </template>
                  </div>
                  <div class="w-1/12 pt-8 text-center">
                    <button class="text-red-500 pl-2" @click.prevent="removeSMSInput(i)"><BaseIcon icon="minus-circle" /></button>
                  </div>
                </div>
                <div class="w-full">
                  <button class="btn-blue-outline mt-2" @click.prevent="addSMSInput()">{{ $t('create_alarm_central_page.add_button') }} <BaseIcon icon="plus" class="ml-1" /></button>
                </div>
              </div>
            </div>

            <div class="mx-2 border-b border-secondary-400 my-5"></div>

            <div class="flex flex-wrap">
              <div class="w-full flex-col px-2 py-2">
                <div class="w-full text-gray-600 text-sm font-bold pb-2 font-serif">{{ $t('create_alarm_central_page.tcp_section') }}</div>
                <div class="w-full flex flex-wrap mt-2" v-for="(n, i) in report_ips" :key="i">
                  <div class="w-3/12 pr-2">
                    <BaseInput v-model="n.ip" maxlength="255" type="text" :field_name="$t('create_alarm_central_page.ip_address') + ' ' + (i + 1)" rules="required" />
                  </div>
                  <div class="w-2/12 pr-2">
                    <BaseInput v-model="n.port" @keypress="isNumber($event)" min="0" max="65535" :placeholder="$t('create_alarm_central_page.port')" type="number" :field_name="$t('create_alarm_central_page.port') + ' ' + (i + 1)" rules="required" />
                  </div>
                  <div class="w-3/12 pr-2">
                    <BaseSelect v-model="n.device_identifier" :options="deviceIdentifiers" nameSelector="name" optionSelector="id" :field_name="$t('create_alarm_central_page.device_identifier_tcp') + ' ' + (i + 1)" rules="required" />
                  </div>
                  <div class="w-3/12 pr-2">
                    <BaseSelect v-model="n.report_format" :options="reportFormats" nameSelector="name" optionSelector="id" :field_name="$t('create_alarm_central_page.report_format_tcp') + ' ' + (i + 1)" rules="required" />
                  </div>
                  <div class="w-1/12 pt-8 text-center">
                    <button class="text-red-500 pl-2" @click.prevent="removeIPInput(i)"><BaseIcon icon="minus-circle" /></button>
                  </div>
                </div>
                <div class="w-full">
                  <button class="btn-blue-outline mt-2" @click.prevent="addIPInput()">{{ $t('create_alarm_central_page.add_button') }} <BaseIcon icon="plus" class="ml-1" /></button>
                </div>
              </div>
            </div>

            <div class="mx-2 border-b border-secondary-400 my-5"></div>

            <div class="flex flex-wrap">
              <div class="w-full md:w-1/3 flex-col px-2 py-2">
                <div class="w-full text-gray-600 text-sm font-bold pb-2 font-serif">{{ $t('create_alarm_central_page.report_type_section') }}</div>
                <div class="w-full" v-for="r in reportTypes" :key="r.id">
                  <label class="inline-flex items-center mt-3">
                    <input v-model="report_types" :value="r.id" type="checkbox" class="form-checkbox h-4 w-4" /><span class="ml-2 text-sm font-sans font-semibold">{{ r.name }}</span>
                  </label>
                </div>
              </div>
            </div>

            <div class="mx-2 border-b border-secondary-400 my-5"></div>

            <div class="flex flex-wrap">
              <div class="w-full md:w-1/3 px-2 py-2">
                <label class="inline-flex items-center mt-3"> <input v-model="periodic_report.active" type="checkbox" class="form-checkbox h-4 w-4" /><span class="ml-2 text-sm font-sans font-semibold">{{ $t('create_alarm_central_page.periodic_report') }}</span> </label>
              </div>
              <div v-if="periodic_report && periodic_report.active" class="w-full md:w-1/3 px-2 py-2">
                <BaseSelect v-model="periodic_report.trigger" :options="periodicReportTriggers" nameSelector="name" optionSelector="id" :field_name="$t('create_alarm_central_page.trigger')" rules="required" />
              </div>
              <div v-if="periodic_report && periodic_report.active && periodic_report.trigger == 'critical'" class="w-full md:w-1/3 px-2 py-2">
                <BaseInput v-model="periodic_report.time_limit" @keypress="isNumber($event)" min="0" max="120" placeholder="Minutes" type="number" :field_name="$t('create_alarm_central_page.time')" rules="required" />
              </div>
            </div>

            <div class="mx-2 border-b border-secondary-400 my-5"></div>

            <div class="flex flex-wrap" v-if="isNorwegianSite">
              <div class="w-full md:w-1/3 px-2 py-2">
                <label class="inline-flex items-center mt-3">
                  <input v-model="guard_dispatch" type="checkbox" class="form-checkbox h-4 w-4" />
                  <span class="ml-2 text-sm font-sans font-semibold">{{ $t('create_alarm_central_page.guard_dispatch') }}</span>
                </label>
                <p class="text-xs text-gray-500 mt-1 ml-6">{{ $t('create_alarm_central_page.guard_dispatch_hint') }}</p>
              </div>
            </div>

            <div class="md:w-1/5">
            <BaseInput v-model="alarm_center_fee" type="number" :field_name="$t('create_alarm_central_page.alarm_center_fee')" />
            </div>

            <div class="mx-2 border-b border-secondary-400 my-5"></div>
            <div class="flex flex-wrap">
              <div class="w-full px-2">
                <div class="clearfix">
                  <button class="btn-blue float-right text-lg py-2 px-5" type="submit" @click.prevent="createAlarmCentral()">
                    {{ $t('create_alarm_central_page.save') }}
                    <BaseIcon icon="arrow-right" class="ml-2" />
                  </button>
                </div>
              </div>
            </div>
          </form>
        </ValidationObserver>
      </div>
    </div>
  </div>
</template>

<script>
import * as siteContext from "@/utils/siteContext";
import { communicationLanguageOptions, communicationLanguageOf } from "@/utils/alarmCenterLanguage";

export default {
  siteContext,
  title() {
    return `${this.$t('create_alarm_central_page.page_title')} | SecurCloud`;
  },

  data() {
    return {
      reportTypes: [
        { name: this.$t('create_alarm_central_page.report_type_push_button'), id: "push_button" },
        { name: this.$t('create_alarm_central_page.report_type_man_down'), id: "man_down" },
        { name: this.$t('create_alarm_central_page.report_type_timer_alarm'), id: "timer_alarm_stop" },
        { name: this.$t('create_alarm_central_page.report_type_call_b'), id: "call_b" },
      ],
      deviceIdentifiers: [
        { name: this.$t('create_alarm_central_page.device_identifier_imei'), id: "imei_number" },
        { name: this.$t('create_alarm_central_page.device_identifier_phone'), id: "phone" },
        { name: this.$t('create_alarm_central_page.device_identifier_alarm_number'), id: "alarm_number" },
      ],
      reportFormats: [
        { name: this.$t('create_alarm_central_page.report_format_ovls_bm'), id: "ovls_bm" },
        { name: this.$t('create_alarm_central_page.report_format_srt'), id: "srt" },
        { name: this.$t('create_alarm_central_page.report_format_shortxml'), id: "shortxml" },
        { name: this.$t('create_alarm_central_page.report_format_signal_proto'), id: "signal_proto" },
        { name: this.$t('create_alarm_central_page.report_format_ovls_tempest'), id: "ovls_tempest" },
        { name: this.$t('create_alarm_central_page.report_format_ovls_avarn'), id: "ovls_avarn" },
        { name: this.$t('create_alarm_central_page.report_format_mptp'), id: "mptp" },
        { name: this.$t('create_alarm_central_page.report_format_avarn_json'), id: "avarn_json" },
        { name: this.$t('create_alarm_central_page.report_format_user_defined'), id: "user_defined" },
        { name: "SIA-Safe-4", id: "sia" }, // SIA DC-09 — used to tunnel alarms to Safe-4 (SEC-210)
      ],
      additionalSettings: [
        { name: this.$t('create_alarm_central_page.additional_setting_gmap'), id: "gmap_link" },
        { name: this.$t('create_alarm_central_page.additional_setting_tag_address'), id: "tag_address" },
      ],
      periodicReportTriggers: [
        { name: this.$t('create_alarm_central_page.trigger_always'), id: "always" },
        { name: this.$t('create_alarm_central_page.trigger_critical'), id: "critical" },
      ],
      name: "",
      email: "",
      phone: "",
      // the portal's language until the admin picks another
      communication_language: communicationLanguageOf(null),
      report_phones: [],
      report_ips: [],
      report_types: [],
      periodic_report: {
        active: false,
        trigger: "critical",
        time_limit: 60,
      },
      guard_dispatch: false,
      alarm_center_fee: 0,
    };
  },

  computed: {
    user() {
      return this.$store.state.user;
    },
    isNorwegianSite() {
      return this.$options.siteContext.isNorwegianSite();
    },
    communicationLanguages() {
      return communicationLanguageOptions(this.$t.bind(this));
    },
  },

  methods: {
    createAlarmCentral() {
      this.$refs.formCreateAlarmCentral.validate().then((success) => {
        if (!success) {
          return;
        }

        // validate IP address
        let isValid = this.validateIPaddresses(this.report_ips);
        if (isValid == false) {
          this.handleError(null, this.$t('create_alarm_central_page.error_invalid_ip'));
          return;
        }

        let emails = this.email.replace(/\s+/g, "").split(",");
        let emails_filtered = [];
        emails.forEach((e) => {
          if (this.validateEmail(e)) emails_filtered.push(e);
        });
        emails_filtered = emails_filtered.join();

        let data = {
          name: this.name,
          email: emails_filtered,
          phone: this.phone,
          communication_language: this.communication_language,
          report_phones: this.report_phones,
          report_ips: this.report_ips,
          report_types: this.report_types,
          periodic_report: this.periodic_report,
          guard_dispatch: this.guard_dispatch,
          alarm_center_fee: this.alarm_center_fee,
        };

        this.axios
          .post(`${process.env.VUE_APP_SERVER_URL}/alarm-central/`, data)
          .then((response) => {
            const alarmCentralId = response.data.data._id;
            return this.axios.post(`${process.env.VUE_APP_SERVER_URL}/products`, {
              name: this.name,
              type: this.name.toLowerCase().replace(/\s+/g, '_'),
              category: "alarm_central_supplier",
              manufacturer: "other",
              purchase_price: this.alarm_center_fee,
              articleNumber: alarmCentralId,
            });
          })
          .then(() => {
            this.$router.push({ name: "alarm_central" });
          })
          .catch((error) => {
            this.handleError(error);
          });
      });
    },

    validateEmail: function(e) {
      //eslint-disable-next-line
      let emailRegex = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
      return emailRegex.test(e);
    },

    validateIPaddresses(ipAddresses) {
      let ipRegex = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
      let domainRegex = /^([a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}$/;
      let isValid = true;
      ipAddresses.forEach((a) => {
        if (!ipRegex.test(a.ip) && !domainRegex.test(a.ip)) isValid = false;
      });

      return isValid;
    },

    addSMSInput() {
      this.report_phones.push({ msisdn: "", device_identifier: "", report_format: "", additional_settings: [] });
    },

    removeSMSInput(i) {
      this.report_phones.splice(i, 1);
    },

    addIPInput() {
      this.report_ips.push({ ip: "", port: "", device_identifier: "", report_format: "" });
    },

    removeIPInput(i) {
      this.report_ips.splice(i, 1);
    },

    isNumber: function(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
  },

  created() {
    this.setPageTitle(this.$t('create_alarm_central_page.page_title'), "create_alarm_central");
  },
};
</script>
